import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import OverlayTooltip from '../common/UI/OverlayTooltip';
import BrandAgentIcon from '../../assets/icon-brand-agent.svg?react';
import BrandAgentPreferences from './BrandAgentPreferences';
import useElysiaStore from '@/app/elysia-store';

interface BrandAgentModalProps {
  initiated: boolean;
  setInitiated: (boolean) => void;
}
const BrandAgentModal = ({ initiated, setInitiated }: BrandAgentModalProps) => {
  const setChatAgent = useElysiaStore.getState().setChatAgent;

  const [isBrandModalOpen, setIsBrandModalOpen] = useState<boolean>(false);
  const [canSave, setCanSave] = useState<boolean>(false);
  const [savePreferences, setSavePreferences] = useState<boolean>(false);
  const { name } = useElysiaStore();

  useEffect(() => {
    if (initiated) {
      setIsBrandModalOpen(true);
    }
  }, [initiated]);

  const handleClose = () => {
    setIsBrandModalOpen(false);
    setInitiated(false);
  };

  const handleModalClick = () => {
    setInitiated(true);
    setIsBrandModalOpen(true);
    setSavePreferences(false);
  };

  const handleSave = () => {
    setSavePreferences(true);
    setChatAgent?.('app-agent');
  };
  return (
    <>
      <OverlayTooltip
        tooltipText="Brand Agent"
        buttonContent={<BrandAgentIcon />}
        ariaLabel="brand agent"
        testId="brand-agent"
        tooltipClassName="tooltip-sidebar"
        buttonClassName={`brand-agent ${name === 'Brand Agent' ? 'selected' : ''}`}
        placement="top-start"
        onClick={handleModalClick}
      />
      {isBrandModalOpen && (
        <Modal
          show={isBrandModalOpen}
          onHide={handleClose}
          aria-label="Brand Agent Modal"
          dialogClassName="custom-modal"
          className="brand-agent-modal"
          backdropClassName="custom-backdrop"
          centered
          id="brand-agent-modal"
        >
          <Modal.Header className="custom-header">
            <div className="header-content">
              <Modal.Title data-testid="brand-agent-header">Brand Agent</Modal.Title>
              <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                ×
              </button>
            </div>
            <div className="instruction-row">
              {/* <ElysiaBrain /> */}
              <span>Please select the options below to update the conversation.</span>
            </div>
          </Modal.Header>
          <Modal.Body className="pt-0">
            <div>
              <BrandAgentPreferences
                savePreferences={savePreferences}
                setCanSave={setCanSave}
                handleClose={handleClose}
              />
              <Button
                disabled={!canSave}
                onClick={handleSave}
                data-testid="update-button"
                className="update-btn"
              >
                Update
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default BrandAgentModal;
